function Chart({ data, title }) {
  return (
    <div className="chart">
      <h3>{title}</h3>
      <div>
        <ul>{data.map((el, i) => <li  key={el.nom + "-" + i}>{el.nom}</li>)}</ul>

        <ul>
          {data.map((el, i) => (
            <li key={el.nom + "-" + i} style={{ width: el.note * 10 + "%" }}>{<p>{el.note}/10</p>}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Chart;
